import { Component, OnDestroy, OnInit } from '@angular/core';

import { AlertService } from '../../core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ErrorHelper } from '../../identity/helpers/error.helper';
import { AlertDialogComponent } from '../../pilotpay/dialogs';
import { Environment } from '../../../environments/environment';
import { Subscription } from 'rxjs';

@Component({
	selector: 'app-errors',
	templateUrl: './errors.component.html',
	styleUrls: ['./errors.component.scss']
})
export class ErrorsComponent implements OnInit, OnDestroy {
	constructor(public alertService: AlertService, private matDialog: MatDialog) {}

	public closingIndexes: number[] = [];

	private isDialogOpen: boolean = false;

	private subscription?: Subscription;

	ngOnInit(): void {
		this.subscription = this.alertService.authorizationError.subscribe(error => {
			if (!error || this.isDialogOpen) {
				return;
			}

			const config: MatDialogConfig = new MatDialogConfig();

			config.data = {
				modalType: 'authError',
				name: ErrorHelper.extractMessage(error)
			};

			this.isDialogOpen = true;

			this.matDialog
				.open(AlertDialogComponent, config)
				.afterClosed()
				.subscribe((isTrue: boolean) => {
					this.isDialogOpen = false;
					this.alertService.clearErrors();
					if (isTrue) {
						window.location.href = `${
							new Environment().getConfiguration().frontendIdentityUrl
						}/apps/pilot-pay?redirect=true`;
					}
				});
		});
	}

	ngOnDestroy(): void {
		this.subscription?.unsubscribe();
	}

	close(i: number): void {
		this.closingIndexes.push(i);

		setTimeout(() => {
			this.closingIndexes.splice(this.closingIndexes.indexOf(i), 1);
			this.alertService.removeError(i);
		}, 300);
	}
}
